/*
 * @Author: Fan
 * @Date: 2020-04-16 20:44:13
 * @description:
 * @LastEditors: Fu Zhuohang
 */
import { selectControlOptions } from "../../../component-schema";
import { DataType } from "../../../typings";
import i18n from "../../../i18n";
export default {
    $id: "checkbox",
    type: DataType.Object,
    $ref: selectControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.Number,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        direction: {
            type: DataType.String,
            title: i18n.t('dataitem.WebDirection').toString(),
            default: "horizontal",
        },
        dataLinkage: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLinkage').toString(),
        },
        displaySetting: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplaySetting').toString(),
            default: "showSelected"
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
        readonlyCondition: {
            type: DataType.String,
            title: i18n.t('dataitem.ReadonlyConditions').toString(),
        },
    },
};
